import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { AttivitaEreditataDTO } from "../dto/procedimento-ereditatoDTO";
import { AttivitaEreditataVO } from "../vo/procedimento-ereditatoVO";
import { MapperProcedimento } from "./mapper-procedimento";
import { MapperIstanzaAttivita } from "./mapper-istanza-attivita";

@Injectable({
  providedIn: "root",
})
export class MapperAttivitaEreditata
  implements MapperInterface<AttivitaEreditataDTO, AttivitaEreditataVO> {
  constructor(private mapperAttivita: MapperIstanzaAttivita) {}

  convertVoToDto(vo: AttivitaEreditataVO): AttivitaEreditataDTO {
    if (vo != null) {
      const dto = new AttivitaEreditataDTO();
      dto.attivitaAssociata = this.mapperAttivita.convertVoToDto(
        vo.attivitaAssociata
      );
      dto.idFascicolo = vo.idFascicolo;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: AttivitaEreditataDTO): AttivitaEreditataVO {
    if (dto != null) {
      const vo = new AttivitaEreditataVO();
      vo.attivitaAssociata = this.mapperAttivita.convertDtoToVo(
        dto.attivitaAssociata
      );
      vo.idFascicolo = dto.idFascicolo;

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: AttivitaEreditataVO[]): AttivitaEreditataDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: AttivitaEreditataDTO[]): AttivitaEreditataVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
